import React, { useState, useEffect } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line, Bar } from "react-chartjs-2";
import "./OrdersRevenue.css";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const OrdersRevenue = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    setTimeout(() => {
      setData({
        totalRevenue: 245680,
        totalOrders: 1842,
        avgOrderValue: 133.42,
        pendingOrders: 47,
      });
      setLoading(false);
    }, 500);
  }, []);

  if (loading) {
    return (
      <div className="orders-revenue">
        <h1>Orders & Revenue</h1>
        <div className="loading-container">
          <div className="spinner"></div>
          <p>Loading revenue data...</p>
        </div>
      </div>
    );
  }

  const revenueData = {
    labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
    datasets: [{
      label: "Revenue (BDT)",
      data: [35000, 42000, 38000, 45000, 41000, 44680],
      borderColor: "#4caf50",
      backgroundColor: "rgba(76, 175, 80, 0.1)",
      tension: 0.4,
    }],
  };

  const ordersData = {
    labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
    datasets: [{
      label: "Orders",
      data: [280, 340, 295, 365, 320, 242],
      backgroundColor: "#2196f3",
    }],
  };

  return (
    <div className="orders-revenue">
      <div className="analytics-header">
        <h1>Orders & Revenue Analytics</h1>
      </div>

      <div className="analytics-grid">
        <div className="analytics-card">
          <div className="card-icon revenue">
            <span className="material-icons">account_balance_wallet</span>
          </div>
          <div className="card-content">
            <h3>Total Revenue</h3>
            <p className="metric-value">৳{data.totalRevenue.toLocaleString()}</p>
          </div>
        </div>

        <div className="analytics-card">
          <div className="card-icon orders">
            <span className="material-icons">shopping_cart</span>
          </div>
          <div className="card-content">
            <h3>Total Orders</h3>
            <p className="metric-value">{data.totalOrders.toLocaleString()}</p>
          </div>
        </div>

        <div className="analytics-card">
          <div className="card-icon avg">
            <span className="material-icons">calculate</span>
          </div>
          <div className="card-content">
            <h3>Avg Order Value</h3>
            <p className="metric-value">৳{data.avgOrderValue}</p>
          </div>
        </div>

        <div className="analytics-card">
          <div className="card-icon pending">
            <span className="material-icons">pending</span>
          </div>
          <div className="card-content">
            <h3>Pending Orders</h3>
            <p className="metric-value">{data.pendingOrders}</p>
          </div>
        </div>
      </div>

      <div className="charts-grid">
        <div className="chart-card">
          <h3>Revenue Trend</h3>
          <div className="chart-container">
            <Line data={revenueData} options={{ responsive: true, maintainAspectRatio: false }} />
          </div>
        </div>

        <div className="chart-card">
          <h3>Monthly Orders</h3>
          <div className="chart-container">
            <Bar data={ordersData} options={{ responsive: true, maintainAspectRatio: false }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrdersRevenue;
